import React, { useState, useEffect, useRef } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import Logo from "../Icons/Logo";
import CloseIcon from "../Icons/CloseIcon";
import MenuIcon from "../Icons/MenuIcon";
import SomeIcons from "../Icons/SomeIcons";
import ArrowRight from "components/Icons/ArrowRight";
import { useChildrenCategories } from "hooks";
import { sortBySlug } from "lib/utils";

const SideMenu = () => {
  const router = useRouter();
  const pathname = router.asPath;
  const [showSideBar, setSideBar] = useState(false);
  const [openCategory, setOpenCategory] = useState(false);
  const { data: categories } = useChildrenCategories(false);
  const SideBar = useRef(null);

  useEffect(() => {
    if (!showSideBar) return;

    const closeBar = (event) => {
      if (SideBar.current && !SideBar.current.contains(event.taget)) {
        setSideBar(false);
      }
      window.addEventListener("onclick", closeBar);
    };
  }, [showSideBar]);

  return (
    <>
      <div className="flex pt-10 pl-11 items-center w-full phone-100:pt-6 phone-100:pl-6">
        <button
          className="text-4xl"
          type="button"
          onClick={() => setSideBar(!showSideBar)}
          role="menuitem"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <MenuIcon />
        </button>
        <Link href="/">
          <a className="ml-12 phone-100:pl-0 phone-100:w-full phone-100:flex phone-100:justify-center">
            <img
              src="/images/Logo.png"
              className="max-w-[307px] phone-100:max-w-[181px] self-start"
            />
          </a>
        </Link>
      </div>
      {showSideBar && (
        <>
          <div
            className="blurBackdrop overlay z-200 bg-whiteTransparent fixed h-screen w-screen backdrop-filter backdrop-blur-lg top-0"
            onClick={() => setSideBar(!showSideBar)}
          ></div>
          <div className="z-300 h-screen fixed bg-white-100 w-full max-w-sm top-0 flex flex-col overflow-y-auto overflow-x-none tablet:max-w-full">
            <button
              role="button"
              type="button"
              className="font-light text-9xl px-14 pt-10"
              onClick={() => setSideBar(!showSideBar)}
            >
              <CloseIcon />
            </button>
            <div className="border-1 border-menuBorder mt-7 mb-10 mx-14"></div>
            <div>
              <ul role="menu" aria-label="navigaatiovalikko">
                <li role="menuitem" className="font-bold text-3xl py-2">
                  <Link href="/">
                    <a
                      className={`pr-3 pl-[49px] border-l-[9px] border-transparent block w-full ${
                        pathname === "/" ? "!border-blue" : ""
                      }`}
                      onClick={() => setSideBar(!showSideBar)}
                    >
                      Etusivu
                    </a>
                  </Link>
                </li>
                <li role="menuitem" className="font-bold text-3xl py-2">
                  <Link href="/suorat-lahetykset">
                    <a
                      className={`pr-3 pl-[49px] border-l-[9px] border-transparent block w-full ${
                        pathname === "/suorat-lahetykset" ? "!border-blue" : ""
                      }`}
                      onClick={() => setSideBar(!showSideBar)}
                    >
                      Suorat lähetykset
                    </a>
                  </Link>
                </li>
                <li role="menuitem" className="font-bold text-3xl py-2">
                  <Link href="/tulevat-lahetykset">
                    <a
                      className={`pr-3 pl-[49px] border-l-[9px] border-transparent block w-full ${
                        pathname === "/tulevat-lahetykset" ? "!border-blue" : ""
                      }`}
                      onClick={() => setSideBar(!showSideBar)}
                    >
                      Tulevat lähetykset
                    </a>
                  </Link>
                </li>
                <li role="menuitem" className="font-bold text-3xl py-2">
                  <Link href="/menneet-lahetykset">
                    <a
                      className={`pr-3 pl-[49px] border-l-[9px] border-transparent block w-full ${
                        pathname === "/menneet-lahetykset" ? "!border-blue" : ""
                      }`}
                      onClick={() => setSideBar(!showSideBar)}
                    >
                      Menneet lähetykset
                    </a>
                  </Link>
                </li>
                <li role="menuitem" className="font-bold text-3xl py-2">
                  <Link href="/kirkot">
                    <a
                      className={`pr-3 pl-[49px] border-l-[9px] border-transparent block w-full ${
                        pathname === "/kirkot" ? "!border-blue" : ""
                      }`}
                      onClick={() => setSideBar(!showSideBar)}
                    >
                      Kirkot
                    </a>
                  </Link>
                </li>
                <li role="menuitem">
                  <button
                    className="font-bold text-3xl pr-3 flex items-baseline justify-center pl-14 w-full"
                    onClick={() => setOpenCategory(!openCategory)}
                  >
                    <span className="inline-block mr-3">Kategoriat</span>
                    <span
                      className={`"ml-2 transition duration-300 ease-in-out inline-block mr-auto "${
                        openCategory
                          ? "transform rotate-90"
                          : "transform -rotate-90"
                      } `}
                    >
                      <ArrowRight color={"#000"} />
                    </span>
                  </button>
                  {openCategory && (
                    <ul
                      role="menu"
                      aria-label="Navigaatiovalikko kategorioille"
                    >
                      {categories
                        .filter(
                          (category) =>
                            category.slug !== "suosittelemme-etusivu"
                        )
                        .sort(sortBySlug)
                        .map((category) => (
                          <li
                            role="menuitem"
                            className={"text-xl font-bold text-gray"}
                            key={category.slug}
                          >
                            <Link href={`/kategoria/${category.slug}`}>
                              <a
                                className={`pr-3 pl-[4.625rem] border-l-[9px] border-transparent block w-full ${
                                  pathname === `/kategoria/${category.slug}`
                                    ? "!border-blue"
                                    : ""
                                }`}
                                onClick={() => setSideBar(!showSideBar)}
                              >
                                {category.name}
                              </a>
                            </Link>
                          </li>
                        ))}
                    </ul>
                  )}
                </li>
                {/*<li
                  role="menuitem"
                  className={`font-bold text-3xl py-2 pr-3 pl-[49px] border-l-[9px] border-transparent ${
                    pathname === "/lahjoita/123" ? "!border-blue" : ""
                  }`}
                  onClick={() => setSideBar(!showSideBar)}
                >
                  <Link href="/lahjoita/123">
                    <a>Lahjoita</a>
                  </Link>
                </li>
                <li role="menuitem" className="font-bold text-3xl py-2">
                  <Link href="/ohje">
                    <a
                      className={`pr-3 pl-[49px] border-l-[9px] border-transparent block w-full ${
                        pathname === "/ohje" ? "!border-blue" : ""
                      }`}
                      onClick={() => setSideBar(!showSideBar)}
                    >
                      Ohje
                    </a>
                  </Link>
                </li>
                <li role="menuitem" className="font-bold text-3xl py-2">
                  <Link href="/yhteystiedot">
                    <a
                      className={`pr-3 pl-[49px] border-l-[9px] border-transparent block w-full ${
                        pathname === "/yhteystiedot" ? "!border-blue" : ""
                      }`}
                      onClick={() => setSideBar(!showSideBar)}
                    >
                      Yhteystiedot
                    </a>
                  </Link>
                </li>*/}
              </ul>
            </div>
            <div className="border-b-1 border-menuBorder mt-auto mb-8 pt-8 mx-14"></div>

            <div className="px-14 pb-10">
              <img
                src="/images/Logo.png"
                className="max-w-[181px] m-auto"
              ></img>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SideMenu;
